// extracted by mini-css-extract-plugin
module.exports = {"container":"ReportAdd_container__ShYlb","active":"ReportAdd_active__3eiDz","button":"ReportAdd_button__3B_gd","icon":"ReportAdd_icon__3M4fc","name":"ReportAdd_name__37iI5"};